import type { Middleware } from "@reduxjs/toolkit";

import type { RootState } from "@/app/store";
import { activeStoreCleared, activeStoreSelected } from "@/features/settings/activeStoreSlice";

const prefix = "merry.store-preference.v1";
export function storePreferenceKey(userId: string, organizationId: string) {
  return `${prefix}:${encodeURIComponent(userId)}:${encodeURIComponent(organizationId)}`;
}
export function readStorePreference(userId: string, organizationId: string): string {
  if (!userId || !organizationId) return "";
  try {
    const value = localStorage.getItem(storePreferenceKey(userId, organizationId));
    return value && value.length <= 200 ? value : "";
  } catch { return ""; }
}
export function resolveStorePreference(saved: string, visibleIds: readonly string[]) {
  return visibleIds.includes(saved) ? saved : visibleIds.length === 1 ? visibleIds[0] : "";
}
// 只持久化已由绑定列表核验的 ID；凭据和店铺展示信息不进入本机偏好。
export const activeStorePreferenceMiddleware: Middleware = api => next => action => {
  const result = next(action);
  if (activeStoreSelected.match(action) || activeStoreCleared.match(action)) {
    const state = api.getState() as RootState;
    const userId = state.authSession.actor?.userId;
    if (!userId) return result;
    const key = storePreferenceKey(userId, action.payload.organizationId);
    try {
      if (activeStoreSelected.match(action)) localStorage.setItem(key, action.payload.storeBindingId);
      else localStorage.removeItem(key);
    } catch { /* 浏览器拒绝存储时，本次会话仍可选店。 */ }
  }
  return result;
};
